<div class="table">
  <div class="row header">
    <div class="column">Bostad</div>
    <div class="column">Driftskostnad</div>
    <div class="column">Fastighetsavgift</div>
    <div class="column">Avgift/Hyra</div>
    <div class="column">Summa</div>
  </div>
  @for (property of this.kalpylator().properties; track property) {
    <div class="row">
      <div class="column">{{ property.propertyType }}</div>
      <div class="column">{{ property.runCost | number: '1.0-0' : 'sv' }}</div>
      <div class="column">{{ property.tax | number: '1.0-0' : 'sv' }}</div>
      <div class="column">{{ property.rent | number: '1.0-0' : 'sv' }}</div>
      <div class="column">{{ property.monthlyCost | number: '1.0-0' : 'sv' }}</div>
    </div>
  }

  <div class="row">
    <div class="column sum">Totalt</div>
    <div class="column">
      {{ kalpylator().monthlyPropertyRunCost | number: '1.0-0' : 'sv' }}
    </div>
    <div class="column">
      {{ kalpylator().monthlyPropertyTax | number: '1.0-0' : 'sv' }}
    </div>
    <div
      class="column">{{ kalpylator().monthlyPropertyRent | number: '1.0-0' : 'sv' }}
    </div>
    <div
      class="column">{{ kalpylator().monthlyPropertyCost | number: '1.0-0' : 'sv' }}
    </div>
  </div>
  <div class="copy-to-right">
    <spb-copy [copy]="copy"></spb-copy>
  </div>

</div>
